<template>
  <div>
    <v-navigation-drawer  v-if="isConnected" v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
      <v-list dense>
        <v-list-item v-for="menuItem in this.menuItemFilterAccess" :key="menuItem.titre">
          <v-list-item-action>
            <v-icon v-if="menuActiv(menuItem)" color="primary">{{ menuItem.logo }}</v-icon>
            <v-icon v-else >{{ menuItem.logo }}</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>
              <router-link v-if="menuHasAccess(menuItem)" class="routerLink" :to="{ name: menuItem.route }" >
                <span v-if="menuActiv(menuItem)" class="primary--text">{{ $t(menuItem.titre) }}</span>
                <span v-else >{{ $t(menuItem.titre) }}</span>
              </router-link>
              <span v-else class="routerLinkForbidden" >{{ $t(menuItem.titre) }}</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>


        <v-list-group v-for="menu in this.menusFilterAccess" :key="menu.titre">


          <template v-slot:activator>
            <v-list-item-action >
              <v-icon v-if="menuParentActiv(menu)" color="primary">{{ menu.logo }}</v-icon>
              <v-icon v-else >{{ menu.logo }}</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>
                <span v-if="menuParentActiv(menu)" class="primary--text">{{ $t(menu.titre) }}</span>
                <span v-else >{{ $t(menu.titre) }}</span>
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list class="secondary sub_menu">
            <v-list-item v-for="submenu in menu.children" :key="submenu.titre">
              <v-list-item-action>
                <v-icon v-if="menuActiv(submenu)" color="primary">{{ submenu.logo }}</v-icon>
                <v-icon v-else >{{ submenu.logo }}</v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>
                  <router-link v-if="menuHasAccess(submenu)" class="routerLink" :to="{ name: submenu.route }" >
                    <span v-if="menuActiv(submenu)" class="primary--text">{{ $t(submenu.titre) }}</span>
                    <span v-else >{{ $t(submenu.titre) }}</span>
                  </router-link>
                  <span v-else class="routerLinkForbidden" >{{ $t(submenu.titre) }}</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="darken-3" dark>
      <template v-if="isConnected"><v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon></template>
      <v-toolbar-title
          class="ml-0 pl-4"
      >
        <v-img
            class="hidden-xs-and-down mx-2 cursorpointer"
            src="@/assets/logo_dark.png"
            alt="LynxWorkflow"
            position="Left"
            max-height="32"
            max-width="100"
            contain
            @click="toHome"
        ></v-img>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <template v-if="isConnected">
        <NotificationNavigation ref="NotificationNavigation" />
        <ProfilNavigation ref="ProfilNavigation" />
      </template>
      <v-divider inset vertical ></v-divider>
      <LanguageNavigation ref="LanguageNavigation" />
    </v-app-bar>
  </div>
</template>

<script>

import NotificationNavigation from '../notification/Navigation.vue';
import ProfilNavigation from '../profil/Navigation.vue';
import LanguageNavigation from '../home/LanguageNavigation.vue';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'Navigation',
  mixins: [AccessMixin],
  components: {
    NotificationNavigation,
    ProfilNavigation,
    LanguageNavigation,
  },
  props: {
    isConnected: {
      type: Boolean,
      required: true
    },

  },


  data: () => ({
    drawer: null,
    menuItems : [
      {
        titre: 'order.orders',
        logo: 'mdi-basket',
        route: 'OrderList',
        access : ['order_read'],
      },
      {
        titre: 'printer.printers',
        logo: 'mdi-printer-3d',
        route: 'PrinterList',
        access : ['printer_read'],
      },
      {
        titre: 'menu.orderactions',
        logo: 'mdi-alert-decagram',
        route: 'OrderActionList',
        access: ['action_read'],
      },
      {
        titre: 'menu.prodfile',
        logo: 'mdi-file-powerpoint',
        route: 'ProdFileList',
        access : ['prodfile_read'],
      },
    ],
    menus : [
      {titre: 'menu.designfile',
      logo: 'mdi-file-cad',
      access: ['designfile_read'],
      children: [
        {
          titre: 'menu.designfile',
          logo: 'mdi-file-cad',
          route: 'DesignFileList',
          access : ['designfile_read'],
        },
        {
          titre: 'menu.catalog',
          logo: 'mdi-book-open-blank-variant',
          route: 'DesignFileCatalog',
          access : ['designfile_read'],
        },
      ]
      },
      {
        titre: 'menu.parameter',
        logo: 'mdi-table-cog',
        access : ['accessory_read','controlunit_read','customer_read','designfiletype_read','industrialcomputer_read','machine_read','material_read','orderstate_read', 'ordertype_read','orderresolution_read', 'nozzle_read', 'printingsurface_read','priority_read','sector_read','tag_read','toolref_read','toolhead_read','verticale_read'],
        children: [
          {
            titre: 'accessory.accessories',
            logo: 'mdi-cctv',
            route: 'AccessoryList',
            access : ['accessory_read'],
          },
          {
            titre: 'controlunit.controlunits',
            logo: 'mdi-car-cruise-control',
            route: 'ControlUnitList',
            access : ['controlunit_read'],
          },
          {
            titre: 'customer.customers',
            logo: 'mdi-account-cash',
            route: 'CustomerList',
            access : ['customer_read'],
          },
          {
            titre: 'designfile.types',
            logo: 'mdi-file-cad',
            route: 'DesignFileTypeList',
            access : ['designfiletype_read'],
          },
          {
            titre: 'industrialcomputer.industrialcomputers',
            logo: 'mdi-server',
            route: 'IndustrialComputerList',
            access : ['industrialcomputer_read'],
          },
          {
            titre: 'machine.machines',
            logo: 'mdi-printer-3d',
            route: 'MachineList',
            access : ['machine_read'],
          },
          {
            titre: 'material.materials',
            logo: 'mdi-format-color-fill',
            route: 'MaterialList',
            access : ['material_read'],
          },
          {
            titre: 'nozzle.nozzles',
            logo: 'mdi-printer-3d-nozzle',
            route: 'NozzleList',
            access : ['nozzle_read'],
          },
          {
            titre: 'order.state',
            logo: 'mdi-basket',
            route: 'OrderStateList',
            access : ['orderstate_read'],
          },
          {
            titre: 'order.type',
            logo: 'mdi-basket',
            route: 'OrderTypeList',
            access : ['ordertype_read'],
          },
          {
            titre: 'order.resolution',
            logo: 'mdi-basket',
            route: 'OrderResolutionList',
            access : ['orderresolution_read'],
          },
          {
            titre: 'order.risk',
            logo: 'mdi-alert',
            route: 'RiskList',
            access: ['order_read'],
          },
          {
            titre: 'orderaction.type',
            logo: 'mdi-alert-decagram',
            route: 'ActionTypeList',
            access : ['actiontype_read'],
          },
          {
            titre: 'printingsurface.printingsurfaces',
            logo: 'mdi-checkerboard',
            route: 'PrintingSurfaceList',
            access : ['printingsurface_read'],
          },
          {
            titre: 'priority.priorities',
            logo: 'mdi-priority-high',
            route: 'PriorityList',
            access : ['priority_read'],
          },
          {
            titre: 'sector.sectors',
            logo: 'mdi-basket',
            route: 'SectorList',
            access : ['sector_read'],
          },
          {
            titre: 'tag.tags',
            logo: 'mdi-tag',
            route: 'TagList',
            access : ['tag_read'],
          },
          {
            titre: 'toolhead.toolheads',
            logo: 'mdi-tools',
            route: 'ToolHeadList',
            access : ['toolhead_read'],
          },
          {
            titre: 'tool.tools',
            logo: 'mdi-tools',
            route: 'ToolrefList',
            access : ['toolref_read'],
          },
          {
            titre: 'verticale.verticales',
            logo: 'mdi-basket',
            route: 'VerticaleList',
            access : ['verticale_read'],
          },
        ]
      },
      {
        titre: 'administration.administration',
        logo: 'mdi-account-cog',
        access : ['user_read','profil_read','security_parameter_read','connexion_user_read','forgot_password_read','updatedlynxapi_read','profilinterface_read'],
        children: [
          {
            titre: 'administration.user.users',
            logo: 'mdi-account',
            route: 'UserList',
            access : ['user_read'],
          },
          {
            titre: 'administration.profil.profils',
            logo: 'mdi-account-group',
            route: 'ProfilUserList',
            access : ['profil_read'],
          },
          {
            titre: 'administration.profil.profilinterfaces',
            logo: 'mdi-account-box-multiple',
            route: 'ProfilInterfaceList',
            access : ['profilinterface_read'],
          },
          {
            titre: 'administration.securityparameter.securityparameters',
            logo: 'mdi-account-cog',
            route: 'SecurityParameterList',
            access : ['security_parameter_read'],
          },
          {
            titre: 'administration.user.connexionusers',
            logo: 'mdi-login',
            route: 'ConnexionUserList',
            access : ['connexion_user_read'],
          },
          {
            titre: 'administration.user.forgotpasswords',
            logo: 'mdi-account-convert',
            route: 'ForgotPasswordList',
            access : ['forgot_password_read'],
          },
          {
            titre: 'updatedlynxapi.updatedlynxapis',
            logo: 'mdi-update',
            route: 'UpdatedLynxapiList',
            access : ['updatedlynxapi_read'],
          },
          {
            titre: 'administration.backup.backups',
            logo: 'mdi-content-save-all',
            route: 'BackupList',
            access : ['backup_read'],
          },
        ]
      },
    ]
  }),
  methods: {
    refreshPage() {
      console.log("refreshPage");
      window.location.reload(false);
    },
    toHome() {
      if (this.$root.isConnected) {
        this.$router.push({ name: `Home` });
      }
    },
    menuActiv(menu) {
      if(menu) {
        let route = this.$route.name;
        route = route.replace("Show", "List");
        route = route.replace("Create", "List");
        route = route.replace("Update", "List");
        route = route.replace("Delete", "List");
        route = route.replace("Enable", "List");
        route = route.replace("Valid", "List");

        if(route == menu.route ) {
          return true;
        }

      }
      return false;
    },
    menuParentActiv(menu) {
      if(menu.children) {
        let route = this.$route.name;
        route = route.replace("Show", "List");
        route = route.replace("Create", "List");
        route = route.replace("Update", "List");
        route = route.replace("Delete", "List");
        route = route.replace("Enable", "List");
        route = route.replace("Valid", "List");
        for (var i = 0; i < menu.children.length; i++) {

          if(menu.children[i].route == route ) {
            return true;
          }
        }
      }
      return false;
    },
  },
  mounted() {

  },
  computed: {
    menuItemFilterAccess() {
      return this.menuItems.filter(this.menuHasAccess);
    },
  },
  watch: {

  }
};
</script>
